import { NotificationButton } from 'components/Notification/NotificationButton'
import { useAuth } from 'context/authentication/useAuth'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../../../assets/logo.svg'
import { featureFlagService } from '../../../utils/featureFlagService'
import { useNavbarStore } from '../navbar-store'
import { NavMenu } from '../NavMenu'
import * as S from './styles'
import { SearchBar } from './SearchBar'

export function AuthenticatedNav() {
  const { logout, user } = useAuth()
  const store = useNavbarStore()
  const featureFlag = featureFlagService()
  const navigate = useNavigate()

  const items = useMemo(() => {
    const out = [
      { label: 'Dashboard', to: '/dashboard' },
      { label: 'Activity', to: store.lastActivityVisited },
      { label: 'Contacts', to: store.lastContactVisited },
      { label: 'Opportunities', to: store.lastOppVisited },
      { label: 'Deals', to: '/deals' },
      { label: 'Rebates', to: store.lastRebateVisited },
    ]

    if (featureFlag.enableCampaigns) {
      out.push({ label: 'Campaigns', to: '/campaigns' })
    }

    if (featureFlag.enableSamples) {
      out.push({ label: 'Samples', to: '/samples' })
    }

    if (featureFlag.enableDocumentLibrary) {
      out.push({ label: 'Documents', to: '/documents' })
    }

    return out
  }, [
    featureFlag.enableCampaigns,
    featureFlag.enableSamples,
    featureFlag.enableDocumentLibrary,
    store,
  ])

  const handleSettingsClick = () => {
    navigate(store.lastSettingsVisited)
  }

  return (
    <S.Wrapper>
      <S.LogoImg src={logo} alt="logo" />
      <NavMenu items={items} />
      {featureFlag.enableSearch && <SearchBar />}
      <S.CompanyTitle>{user?.company?.name}</S.CompanyTitle>
      <S.SettingsIcon onClick={handleSettingsClick} />
      <NotificationButton />
      <S.LogoutIcon onClick={logout} style={{ marginRight: 20 }} />
    </S.Wrapper>
  )
}
